import React from "react";
import { motion } from "framer-motion";

// Circular scan VFX overlay — place inside a relative circular container.
export default function ScanVFX() {
  return (
    <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-hoh-navy/15" />
      {/* rotating scan ring */}
      <motion.div
        className="absolute inset-2 rounded-full border-2 border-hoh-rose/60"
        style={{ borderTopColor: "transparent", borderRightColor: "transparent" }}
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1.6, ease: "linear" }}
      />
      {/* scanning line */}
      <div className="absolute left-0 right-0 h-1 bg-gradient-to-r from-transparent via-hoh-rose to-transparent shadow-[0_0_20px_6px_rgba(220,166,182,0.7)] animate-scan" />
      {/* face mesh lines */}
      <svg className="absolute inset-0 w-full h-full opacity-40" viewBox="0 0 100 100" preserveAspectRatio="none">
        {[20, 40, 60, 80].map((y) => <line key={"h" + y} x1="0" y1={y} x2="100" y2={y} stroke="#DCA6B6" strokeWidth="0.3" />)}
        {[20, 40, 60, 80].map((x) => <line key={"v" + x} x1={x} y1="0" x2={x} y2="100" stroke="#DCA6B6" strokeWidth="0.3" />)}
      </svg>
      {/* particles */}
      {[...Array(6)].map((_, i) => (
        <motion.span
          key={i}
          className="absolute w-1.5 h-1.5 rounded-full bg-hoh-rose"
          style={{ left: `${15 + i * 13}%`, top: "50%" }}
          animate={{ y: [-30, 30, -30], opacity: [0.2, 1, 0.2] }}
          transition={{ repeat: Infinity, duration: 2 + i * 0.2, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}
